import { render } from "./GameStandings.vue?vue&type=template&id=e8d88606&scoped=true"
import script from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"
export * from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"

import "./GameStandings.vue?vue&type=style&index=0&id=e8d88606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d88606"]])

export default __exports__